/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Message_PlaceholderInputs */

const en_form_message_placeholder = /** @type {(inputs: Form_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message`)
};

const ar_form_message_placeholder = /** @type {(inputs: Form_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الرسالة`)
};

const bn_form_message_placeholder = /** @type {(inputs: Form_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`বার্তা`)
};

const de_form_message_placeholder = /** @type {(inputs: Form_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachricht`)
};

const es_form_message_placeholder = /** @type {(inputs: Form_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensaje`)
};

const fr_form_message_placeholder = /** @type {(inputs: Form_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message`)
};

const pt_form_message_placeholder = /** @type {(inputs: Form_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mensagem`)
};

const zh_form_message_placeholder = /** @type {(inputs: Form_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`消息`)
};

const tr_form_message_placeholder = /** @type {(inputs: Form_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesaj`)
};

const ru_form_message_placeholder = /** @type {(inputs: Form_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сообщение`)
};

const pl_form_message_placeholder = /** @type {(inputs: Form_Message_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiadomość`)
};

/**
* | output |
* | --- |
* | "Message" |
*
* @param {Form_Message_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const form_message_placeholder = /** @type {((inputs?: Form_Message_PlaceholderInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Message_PlaceholderInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_form_message_placeholder(inputs)
	if (locale === "bn") return bn_form_message_placeholder(inputs)
	if (locale === "de") return de_form_message_placeholder(inputs)
	if (locale === "es") return es_form_message_placeholder(inputs)
	if (locale === "fr") return fr_form_message_placeholder(inputs)
	if (locale === "pt") return pt_form_message_placeholder(inputs)
	if (locale === "zh") return zh_form_message_placeholder(inputs)
	if (locale === "tr") return tr_form_message_placeholder(inputs)
	if (locale === "ru") return ru_form_message_placeholder(inputs)
	if (locale === "pl") return pl_form_message_placeholder(inputs)
	return en_form_message_placeholder(inputs)
});